import { LOG_ERROR } from './constants';

export function logError(args) {
  return {
    type: LOG_ERROR,
    payload: args,
  };
}
